(function () {
  'use strict';

  var COOKIE_NAME = 'creg_ref';
  var CART_ATTRIBUTE = 'creg_creator__';
  var MAX_AGE_SECONDS = 30 * 24 * 60 * 60;
  var VALID_SLUG = /^[a-z0-9](?:[a-z0-9-]{1,46}[a-z0-9])?$/;

  function validSlug(value) {
    return typeof value === 'string' && VALID_SLUG.test(value);
  }

  function cookieValue(name) {
    var prefix = name + '=';
    var entries = document.cookie ? document.cookie.split('; ') : [];
    for (var index = 0; index < entries.length; index += 1) {
      if (entries[index].indexOf(prefix) === 0) {
        try { return decodeURIComponent(entries[index].slice(prefix.length)); } catch { return ''; }
      }
    }
    return '';
  }

  function storeReferral(slug) {
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = COOKIE_NAME + '=' + encodeURIComponent(slug) + '; Path=/; Max-Age=' + MAX_AGE_SECONDS + '; SameSite=Lax' + secure;
    try { window.localStorage.setItem(COOKIE_NAME, slug); } catch { /* Cookies remain the primary store. */ }
  }

  function storedReferral() {
    var cookie = cookieValue(COOKIE_NAME);
    if (validSlug(cookie)) return cookie;
    try {
      var local = window.localStorage.getItem(COOKIE_NAME) || '';
      if (validSlug(local)) return local;
    } catch { /* Storage can be disabled. */ }
    return '';
  }

  function removeTrackingParameter(url) {
    url.searchParams.delete(COOKIE_NAME);
    window.history.replaceState({}, '', url.pathname + url.search + url.hash);
  }

  async function syncCart(slug) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    try {
      var cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
      if (!cartResponse.ok) return;
      var cart = await cartResponse.json();
      if (cart.attributes && cart.attributes[CART_ATTRIBUTE] === slug) return;
      await fetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { creg_creator__: slug } })
      });
    } catch {
      // The cookie remains available and the next storefront page retries.
    }
  }

  var incoming = '';
  var currentUrl;
  try { currentUrl = new URL(window.location.href); incoming = currentUrl.searchParams.get(COOKIE_NAME) || ''; } catch { incoming = ''; }
  if (validSlug(incoming)) {
    storeReferral(incoming);
    removeTrackingParameter(currentUrl);
  }

  var referral = validSlug(incoming) ? incoming : storedReferral();
  if (!referral) return;

  void syncCart(referral);
}());
